export const EXCLUSIVE = 'exclusive'
export const JOINT_SPOUSES = 'joint_spouses'

export const ALL_OWNERSHIP_TYPES = [EXCLUSIVE, JOINT_SPOUSES] as const

export type OwnershipType = (typeof ALL_OWNERSHIP_TYPES)[number]
